/** Build-time identity shared by version displays and update detection. */
export const runningAppRelease = Object.freeze({ ...__APP_RELEASE__ })
